import Link from 'next/link';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var LandingPageTestamonial = function LandingPageTestamonial(props) {
  return /*#__PURE__*/_jsxs("div", {
    className: "mx-auto px-4 md:px-0 max-w-full md:max-w-3/5 bg-referral-lp-testimonial bg-center bg-cover bg-no-repeat p-12 md:rounded-xl",
    children: [/*#__PURE__*/_jsx("div", {
      className: "flex justify-center mb-4",
      children: /*#__PURE__*/_jsx("img", {
        src: "/images/squiggle-13-lg.png",
        alt: "Squiggle",
        className: "w-16 h-auto"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "font-dmsans text-2xl md:max-w-threequarters mx-auto text-center mb-8",
      children: props.text
    }), /*#__PURE__*/_jsx("div", {
      className: "flex justify-center mb-3",
      children: /*#__PURE__*/_jsx("img", {
        src: props.imageHref,
        alt: "Service Provider",
        className: "rounded-full w-24 h-24"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "font-dmsans font-bold text-lg max-w-3/5 mx-auto text-center mb-1",
      children: props.name
    }), /*#__PURE__*/_jsxs("div", {
      className: "font-dmsans font-normal text-base md:max-w-3/5 mx-auto text-center",
      children: ['Founder, ', /*#__PURE__*/_jsx(Link, {
        href: props.companyHref,
        children: /*#__PURE__*/_jsx("a", {
          className: "font-bold text-subkit-primary",
          target: "_blank",
          rel: "noopener noreferrer",
          children: props.companyName
        })
      })]
    })]
  });
};

export default LandingPageTestamonial;